module.exports = __webpack_public_path__ + "img/dash.4574b064.png";